import React, { FC } from 'react';

import {
  makeStyles, Button, Box, Typography, List, TextField, ListItem,
} from '@material-ui/core';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';

export type Quote = {
  author: string,
  contents: string,
}

const useStyles = makeStyles({
  label: {
    width: '8rem',
  },
  textField: {
    width: '10rem',
  },
});

interface QuotesEditorFormProps {
  quote1Author: string,
  quote1Contents: string,
  quote2Author: string,
  quote2Contents: string,
}

const schema = yup.object().shape({
  quote1Author: yup.string().required(),
  quote1Contents: yup.string().required(),
  quote2Author: yup.string().required(),
  quote2Contents: yup.string().required(),
});

interface QuotesEditorProps {
  catalogSpec: any,
  onUpdate: (quotes: Quote[]) => void,
}

const QuotesEditor: FC<QuotesEditorProps> = (props) => {
  const { catalogSpec, onUpdate } = props;
  const { handleSubmit, register /* temp ~ errors */ } = useForm<QuotesEditorFormProps>({
    validationSchema: schema,
  });
  const classes = useStyles();

  const onSubmit = (values: any) => {
    onUpdate([
      {
        author: values.quote1Author,
        contents: values.quote1Contents,
      }, {
        author: values.quote2Author,
        contents: values.quote2Contents,
      }]);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <List>
        <ListItem>
          <Typography className={classes.label}>CEO</Typography>
          <TextField
            required
            id="quote1author"
            name="quote1author"
            placeholder="author"
            defaultValue={catalogSpec.quotes ? catalogSpec.quotes[0]?.author : ''}
            className={classes.textField}
            inputRef={register}
          />
          &nbsp;
          <TextField
            required
            id="quote1contents"
            name="quote1contents"
            placeholder="contents"
            defaultValue={catalogSpec.quotes ? catalogSpec.quotes[0]?.contents : ''}
            className={classes.textField}
            inputRef={register}
          />
          {/* {errors.name && <Typography>{errors.name}</Typography>} */}
        </ListItem>
        <ListItem>
          <Typography className={classes.label}>CTO</Typography>
          <TextField
            required
            id="quote2author"
            name="quote2author"
            placeholder="author"
            defaultValue={catalogSpec.quotes ? catalogSpec.quotes[1]?.author : ''}
            className={classes.textField}
            inputRef={register}
          />
          &nbsp;
          <TextField
            required
            id="quote2contents"
            name="quote2contents"
            placeholder="contents"
            defaultValue={catalogSpec.quotes ? catalogSpec.quotes[1]?.contents : ''}
            className={classes.textField}
            inputRef={register}
          />
          {/* {errors.label && <Typography>{errors.label}</Typography>} */}
        </ListItem>
      </List>
      <Box style={{ textAlign: 'left', paddingTop: '2rem' }}>
        <Button type="submit"><Typography variant="h6">Update</Typography></Button>
      </Box>
    </form>
  );
};

export default QuotesEditor;
